const BASE_URL = "https://api.leeps.trangotechdevs.com";
// const BASE_URL = "http://api.leeps.trangotechdevs.com:3039";

const API_URL_AUTH = BASE_URL + "/api/user/";
const API_URL = BASE_URL + "/api/dispatcher/";

const INITIAL_TOKEN = "f4ae5389-a941-430c-8836-c25c1886c3c4";

export { API_URL, API_URL_AUTH, BASE_URL, INITIAL_TOKEN };
